module.exports = __webpack_public_path__ + "static/media/step6.86290bc0.png";